import { render, staticRenderFns } from "./LearnAboutLicense.vue?vue&type=template&id=1bf85b3a&scoped=true"
import script from "./LearnAboutLicense.vue?vue&type=script&lang=js"
export * from "./LearnAboutLicense.vue?vue&type=script&lang=js"
import style0 from "./LearnAboutLicense.vue?vue&type=style&index=0&id=1bf85b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf85b3a",
  null
  
)

export default component.exports